import React, { useState } from "react";
import "./FAQ.css";

const faqData = {
  "Training Details": [
    { q: "What is the duration of the program?", a: "The program duration is 6 months." },
    { q: "What training tracks are available in PRT Academy?", a: "We offer Full Stack, Java, and Python tracks." },
    { q: "Why is this program effective for learning full stack development?", a: "It includes real-time projects and mentorship." },
    { q: "How many students will be there in each classroom?", a: "Each class contains around 15 students." },
    { q: "Will class recordings be provided?", a: "Yes, recordings are available." },
    { q: "Will I receive physical notes or study materials?", a: "We provide digital materials and notes." },
    { q: "Can I start applying for jobs during the course?", a: "Yes, you can apply after learning basics." },
    { q: "Can I change my batch during the course?", a: "Yes, based on availability." },
    { q: "What is the eligibility to join this program?", a: "Anyone with interest can join." },
    { q: "Can I switch between online and classroom later?", a: "Yes, switching is allowed." },
    { q: "How can I get my doubts clarified?", a: "Through mentors and live sessions." },
    { q: "Are real-time projects included?", a: "Yes, multiple projects are included." },
    { q: "Will I get certification?", a: "Yes, industry-recognized certification is provided." },
    { q: "Is prior coding knowledge required?", a: "No, we start from basics." },
  ],

  "Placement Support": [
    { q: "How long will I receive the placement support?", a: "Upto 20 Months." },
    { q: "Do I have to take the first job I'm offered?", a: "No, it's your choice." },
    { q: "Is this a job guarantee program?", a: "We provide support, not guarantee." }
  ],

  Eligibility: [
    { q: "Can non-tech students join?", a: "Yes." },
    { q: "Can non-CS students get jobs?", a: "Yes with training." },
    { q: "Do I need a laptop?", a: "Yes." }
  ],

  IRC: [
    { q: "What is IRC?", a: "Industry recognized certificate." },
    { q: "Why is IRC different?", a: "Validates real-world skills." }
  ],

  Fee: [
    { q: "What is the refund policy?", a: "You will be given 50% refund after 20 months if you are not placed based on terms and conditions." },
    { q: "Is EMI available?", a: "Yes." },
  ]
};

const tabs = Object.keys(faqData);

const FAQ = () => {
  const [activeTab, setActiveTab] = useState("Training Details");
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-wrapper">
      <h2 className="faq-title">Frequently Asked Questions</h2>

      <div className="faq-tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => {
              setActiveTab(tab);
              setOpenIndex(null);
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="faq-list">
        {faqData[activeTab].map((item, index) => (
          <div key={index} className="faq-item">

            <div className="faq-question" onClick={() => toggle(index)}>
              <p>{item.q}</p>
              <span>{openIndex === index ? "−" : "+"}</span>
            </div>

            <div className={`faq-answer ${openIndex === index ? "show" : ""}`}>
              <p>{item.a}</p>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;